import Axios from 'axios';
import CONFIG from '../config';

const errorLog = async (details) => {
  let location = window.location.href;
  details.location = location;
  details.createdAt = new Date();
  if (details.userID === undefined || details.userID === null) {
    details.userID = 'UnSignedUser';
  }
  const response = await Axios.post(CONFIG.apiURL + `/errorLog`, details);
};

export default errorLog;
